<style lang="scss">
  @import "@/assets/scss/vuexy/pages/Config.scss";
</style>
<template>
  <div>
    <vx-card class="w-full p-5">
      <div class="text-center w-full text-lg font-bold py-4">{{name}}</div>
      <div class="font-bold text-lg py-4">{{$t('Labels.Alerts')}}</div>
      <div class="container-alerts">
        <minMaxItem 
          :title="$t('Labels.Current')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/circuit`" 
          :uuid="uuid"
          paramMin="electric_current_min" 
          paramMax="electric_current_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="10"
          ></minMaxItem>
        
        <minMaxItem 
          :title="$t('Labels.Voltage')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/circuit`" 
          :uuid="uuid"
          :paramMin="`electric_voltage_min`" 
          :paramMax="`electric_voltage_max`" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ActivePower')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/circuit`" 
          :uuid="uuid"
          paramMin="active_power_min" 
          paramMax="active_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ReactivePower')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/circuit`" 
          :uuid="uuid"
          paramMin="reactive_power_min" 
          paramMax="reactive_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ApparentPower')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/circuit`" 
          :uuid="uuid" 
          paramMin="apparent_power_min" 
          paramMax="apparent_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1000"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.PowerFactor')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/circuit`" 
          :uuid="uuid" 
          paramMin="factor_power_min" 
          paramMax="factor_power_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="1"
          :step="0.1"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ActiveEnergy')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/circuit`" 
          :uuid="uuid"
          paramMin="active_energy_min" 
          paramMax="active_energy_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="4294967295"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.ReactiveEnergy')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/circuit`" 
          :uuid="uuid"
          paramMin="reactive_energy_min" 
          paramMax="reactive_energy_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="4294967295"
          ></minMaxItem>

        <minMaxItem 
          :title="$t('Labels.Frequency')" 
          :min="0" 
          :max="0" 
          unit="" 
          :url="`luminaires_devices/alerts_ranges/circuit`" 
          :uuid="uuid"
          paramMin="frequency_min" 
          paramMax="frequency_max" 
          type="PUT"
          :rangeMin="0"
          :rangeMax="100"
          ></minMaxItem>
      </div>
    </vx-card>
  </div>
</template>
<script>
import minMaxItem from '@/components/minMaxItem/minMaxItem.vue'
import {request} from '@/request.js'

export default {
  components: {
    minMaxItem
  },
  data () {
    return {
      uuid: this.$route.params.uuid,
      name: ''
    }
  },

  methods: {
    async getResponse () {
      const params = {
        url: `luminaires_circuits/${this.uuid}`,
        method: 'GET'
      }
      await request(params).then(response => {
        this.name = response.data.data.name
      }).finally(() => {
        this.$vs.loading.close()
      })
    }
  },
  created () {
    this.getResponse()
  }
}
</script>